import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { createTestimonial } from "./api";
import {
  buildPayload,
  invalidateAllTestimonialsQueries,
  withUploadedVideo,
} from "../query";

export function useCreateTestimonial() {
  return useMutation({
    mutationFn: async ({ item }) => {
      const payload = await withUploadedVideo(buildPayload(item));
      const response = await createTestimonial({ item: payload });
      return response;
    },
    onSuccess: () => {
      toast.success("Testimonial Created Successfully");
      invalidateAllTestimonialsQueries();
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
}
